import classNames from 'classnames';

import {flags} from 'libs/rollout';
import {OptionType} from 'types/stripeType';

import s from './paymentStripe.scss';

const isFacelift = flags.dCheckoutFacelift.isEnabled();

const classes = {
    base: classNames(s.base, {[s.baseFacelift]: isFacelift}),
};

const cardNumberStyle = {
    base: classNames(s.pan, {[s.panFacelift]: isFacelift}),
};

export const settings: OptionType['settings'] = {
    cvv: {
        id: '#cvvStripe',
        option: {
            classes,
            placeholder: 'CVV/CID',
        },
        type: 'cardCvc',
    },
    expiry: {
        id: '#expDateStripe',
        option: {
            classes,
        },
        type: 'cardExpiry',
    },
    pan: {
        id: '#cardNumberStripe',
        option: {
            classes: cardNumberStyle,
            placeholder: 'Card Number',
            showIcon: true,
        },
        type: 'cardNumber',
    },
};
